/**
 * Created by Misa.Qarahqani on 10/9/2019.
 */
import React, {Fragment, useState} from 'react';
import {Avatar, Col, Comment, Icon, Modal, Row, Tag, Tooltip} from 'antd';
import {CommentStatusOptions} from "@models/comment";
import {FormattedMessage} from 'react-intl';
import FormattedDateTime from '@components/custom/FormattedDateTime';


type CommentDetailsPropsType = {
    comment: Comment
};

const Details: React.FC<Comment> = (props: CommentDetailsPropsType) => {
    const {comment} = props;
    const [visible, setVisible] = useState(false);
    const statusObject = CommentStatusOptions.find(opt => opt.value == comment.status);
    return (
        <Fragment>
            <div onClick={() => setVisible(true)}>
                <FormattedMessage id="app.more_details" defaultMessage={`Details`}/>
            </div>
            <Modal
                visible={visible}
                title={null}
                onCancel={() => setVisible(false)}
                footer={null}
            >
                <div className={"details-content"}>
                    <Row>
                        <Col span={10}>
                            <FormattedMessage id="app.video_content_title" defaultMessage={`Video Content Title`}/>
                        </Col>
                        <Col span={14}>
                            <p>{comment.video_content.title}</p>
                        </Col>
                        <Col span={10}>
                            <FormattedMessage id="app.status" defaultMessage={`status`}/>
                        </Col>
                        <Col span={14}>
                            <Tag color={statusObject.color}>{statusObject.label}</Tag>
                        </Col>
                    </Row>
                    <Comment
                        actions={[
                            <span key="comment-basic-like">
                  <Tooltip title="Like">
                    <Icon
                        type="like"
                        theme={`filled`}
                    />
                  </Tooltip>
                <span style={{paddingLeft: 8, cursor: 'auto'}}>{comment.like_count}</span>
                </span>,
                            <span key="comment-basic-dislike">
                  <Tooltip title="Dislike">
                    <Icon
                        type="dislike"
                        theme={`outlined`}
                    />
                  </Tooltip>
                <span style={{paddingLeft: 8, cursor: 'auto'}}>{comment.dislike_count}</span>
                </span>
                        ]}
                        author={<a>{comment.user.name}</a>}
                        avatar={
                            <Avatar
                                src={comment.user.avatar ? comment.user.avatar.path : ""}
                                alt={comment.user.name}
                            />
                        }
                        content={
                            <p>
                                {comment.text}
                            </p>
                        }
                        datetime={
                            <FormattedDateTime date={comment.created_at}/>
                        }
                    />

                </div>
            </Modal>
        </Fragment>
    )
};
export default Details